/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import React from 'react'
import GHGEmissions from './data/GHGEmissions';
import GHGEmissionsIntensity from './data/GHGEmissionsIntensity';
import EnergyConsumption from './data/EnergyConsumption';
import WaterConsumption from './data/WaterConsumption';
import Social from './data/Social';
import Governance from './data/Governance';
import { GenerateChartsProps } from './common';

const GenerateCharts = React.memo((props: GenerateChartsProps) => {
  return <div
    style={{ height: 0, width: 0, overflow: 'hidden' }}
  >
    <GHGEmissions {...props} />
    <GHGEmissionsIntensity {...props} />
    <EnergyConsumption {...props} />
    <WaterConsumption {...props} />
    <Social {...props} />
    <Governance {...props} />
  </div>
})

export default GenerateCharts;
